import styles from "./index.module.css";

export default function OtherApps() {
	return (
		<>
			<div className={styles["container"]}>
				<div className={styles["max-wrap"]}>
					{/* Korean */}
					<div className={styles["wrap"]}>
						<div className={styles["right"]}>
							<div className={styles["title-right"]}>
								Journal: Note, <br></br>Planner, PDFs
								<img src="/imgs/line.svg" className={styles["line"]} alt="" />
							</div>
							<div className={styles["content-right"]}>
								The App empowers you to capture thoughts, track progress, and
								achieve your aspirations. Seamlessly integrated features allow
								for efficient organization and reflection. Elevate your
								productivity and creativity with a digital journaling experience
								that inspires.
							</div>
							<div className={styles["wrap-button"]}>
								<a
									className={styles["button1"]}
									href="https://apps.apple.com/us/app/journal-planner-notes-pdfs/id1664348099"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/white-apple.svg" alt="" />
									<div>App Store</div>
								</a>
								<a
									className={styles["button2"]}
									href="https://play.google.com/store/apps/details?id=journal.notes.planner.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/black-android.svg" alt="" />
									<div>Play Store</div>
								</a>
							</div>
						</div>
						<div className={styles["left"]}>
							<div className={styles["wrap-left"]}>
								<img
									src="/imgs/bg-korean.svg"
									className={styles["bg"]}
									alt=""
								/>
								<div className={styles["wrap-phone"]}>
									<img
										src="/imgs/korean.png"
										className={styles["phone"]}
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>
					{/* German */}
					<div className={styles["wrap"]}>
						<div className={styles["left"] + " " + styles["right-pic"]}>
							<div className={styles["wrap-left"]}>
								<img
									src="/imgs/bg-german.svg"
									className={styles["bg"]}
									alt=""
								/>
								<div className={styles["wrap-phone"]}>
									<img
										src="/imgs/german.png"
										className={styles["phone"]}
										alt=""
									/>
								</div>
							</div>
						</div>
						<div className={styles["right"]}>
							<div className={styles["title-right"]}>
								Theme: Wallpapers <br></br>& Widgets
								<img src="/imgs/line.svg" className={styles["line"]} alt="" />
								<img src="/imgs/arrow.svg" className={styles["arrow"]} alt="" />
							</div>
							<div className={styles["content-right"]}>
								The App designed to elevate your device's aesthetics with a vast
								selection of customizable themes, stunning wallpapers, practical
								widgets, and diverse icon packs. Express your unique style and
								create a digital environment that reflects your personality
								while enhancing productivity and enjoyment.
							</div>
							<div className={styles["wrap-button"]}>
								{/* <a
									className={styles["button1"]}
									href="https://play.google.com/store/apps/details?id=com.themes.wallpapers.widgets.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/white-apple.svg" alt="" />
									<div>App Store</div>
								</a> */}
								<a
									className={styles["button2"]}
									href="https://play.google.com/store/apps/details?id=com.themes.wallpapers.widgets.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/black-android.svg" alt="" />
									<div>Play Store</div>
								</a>
							</div>
						</div>
					</div>
					{/* Toeic */}
					<div className={styles["wrap"]}>
						<div className={styles["right"]}>
							<div className={styles["title-right"]}>
								Ai Keyboard: <br></br>Grammar Check
								<img src="/imgs/line.svg" className={styles["line"]} alt="" />
							</div>
							<div className={styles["content-right"]}>
								Explore our AI Keyboard app, crafted to boost typing speed,
								generate custom content, and include advanced features like AI
								Reply and canned messages. Enjoy seamless communication and
								heightened productivity with a keyboard that adapts effortlessly
								to your unique style and preferences.
							</div>
							<div className={styles["wrap-button"]}>
								{/* <a
									className={styles["button1"]}
									href="https://apps.apple.com/us/app/prep-for-the-toeic-test/id1574067773"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/white-apple.svg" alt="" />
									<div>App Store</div>
								</a> */}
								<a
									className={styles["button2"]}
									href="https://play.google.com/store/apps/details?id=starnest.aitype.aikeyboard.chatbot.chatgpt"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/black-android.svg" alt="" />
									<div>Play Store</div>
								</a>
							</div>
						</div>
						<div className={styles["left"]}>
							<div className={styles["wrap-left"]}>
								<img
									src="/imgs/bg-english.svg"
									className={styles["bg"]}
									alt=""
								/>
								<div className={styles["wrap-phone"]}>
									<img
										src="/imgs/pink.svg"
										className={styles["white"]}
										alt=""
									/>
									<img
										src="/imgs/english.png"
										className={styles["phone"]}
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>
					<img src="/imgs/brush-blue.svg" className={styles["brush"]} alt="" />

{/* German */}
					<div className={styles["wrap"]}>
						<div className={styles["left"] + " " + styles["right-pic"]}>
							<div className={styles["wrap-left"]}>
								<img
									src="/imgs/bg-german.svg"
									className={styles["bg"]}
									alt=""
								/>
								<div className={styles["wrap-phone"]}>
									<img
										src="/imgs/ic_invitation.png"
										className={styles["phone"]}
										alt=""
									/>
								</div>
							</div>
						</div>
						<div className={styles["right"]}>
							<div className={styles["title-right"]}>
								Invitation Maker - <br></br>Card Maker
								<img src="/imgs/line.svg" className={styles["line"]} alt="" />
								<img src="/imgs/arrow.svg" className={styles["arrow"]} alt="" />
							</div>
							<div className={styles["content-right"]}>
								Discover our Invitation Maker app – the perfect tool to create stunning, personalized invitations in minutes. Customize ready-made templates, add text, images, and effects to craft the ideal invite for any event.
Unleash your creativity with a user-friendly interface that saves time and adds a personal touch to every invitation.
							</div>
							<div className={styles["wrap-button"]}>
								{/* <a
									className={styles["button1"]}
									href="https://play.google.com/store/apps/details?id=com.themes.wallpapers.widgets.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/white-apple.svg" alt="" />
									<div>App Store</div>
								</a> */}
								<a
									className={styles["button2"]}
									href="https://play.google.com/store/apps/details?id=com.invitationmaker.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/black-android.svg" alt="" />
									<div>Play Store</div>
								</a>
							</div>
						</div>
					</div>
					{/* Toeic */}
					<div className={styles["wrap"]}>
						<div className={styles["right"]}>
							<div className={styles["title-right"]}>
								Printer: Smart Print Documents
								<img src="/imgs/line.svg" className={styles["line"]} alt="" />
							</div>
							<div className={styles["content-right"]}>
								Our Printer app empowers you to print documents, photos, Word files, and Excel spreadsheets, scan files, and manage PDFs with ease. Its seamlessly integrated features allow you to organize, preview, edit, and share content directly from your device. Simplify everyday printing tasks and boost productivity with a fast, convenient, and reliable mobile printing experience.
							</div>
							<div className={styles["wrap-button"]}>
								{/* <a
									className={styles["button1"]}
									href="https://apps.apple.com/us/app/prep-for-the-toeic-test/id1574067773"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/white-apple.svg" alt="" />
									<div>App Store</div>
								</a> */}
								<a
									className={styles["button2"]}
									href="https://play.google.com/store/apps/details?id=com.printer.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/black-android.svg" alt="" />
									<div>Play Store</div>
								</a>
							</div>
						</div>
						<div className={styles["left"]}>
							<div className={styles["wrap-left"]}>
								<img
									src="/imgs/bg-english.svg"
									className={styles["bg"]}
									alt=""
								/>
								<div className={styles["wrap-phone"]}>
									<img
										src="/imgs/printer.png"
										className={styles["phone"]}
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>

					<div className={styles["wrap"]}>
						<div className={styles["left"] + " " + styles["right-pic"]}>
							<div className={styles["wrap-left"]}>
								<img
									src="/imgs/bg-german.svg"
									className={styles["bg"]}
									alt=""
								/>
								<div className={styles["wrap-phone"]}>
									<img
										src="/imgs/ic_tvremote.png"
										className={styles["phone"]}
										alt=""
									/>
								</div>
							</div>
						</div>
						<div className={styles["right"]}>
							<div className={styles["title-right"]}>
								TV Remote: Universal Remote
								<img src="/imgs/line.svg" className={styles["line"]} alt="" />
								<img src="/imgs/arrow.svg" className={styles["arrow"]} alt="" />
							</div>
							<div className={styles["content-right"]}>
								The application allows users to control compatible Smart TVs directly from their mobile devices. Users can adjust the volume, change channels, navigate TV menus, enter text, use voice search, mirror their phone screen, and cast supported media files to the TV.
							</div>
							<div className={styles["wrap-button"]}>
								{/* <a
									className={styles["button1"]}
									href="https://play.google.com/store/apps/details?id=com.themes.wallpapers.widgets.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/white-apple.svg" alt="" />
									<div>App Store</div>
								</a> */}
								<a
									className={styles["button2"]}
									href="https://play.google.com/store/apps/details?id=com.tvremote.starnest"
									target="_blank"
									rel="noreferrer">
									<img src="/imgs/black-android.svg" alt="" />
									<div>Play Store</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
